<script>
import AppLayoutNoAuth from '@/Layout/AppLayoutNoAuth'
export default {
	layout: AppLayoutNoAuth
}
</script>

<script setup>
import NoActiveMembership from '@/Components/NoActiveMembership.vue'
</script>

<template>
	<NoActiveMembership />
</template>